'use client';

import React__default from 'react';
import { LabelWrapper, ResumeItemWrapper, CvSection } from './ResumeItem.css.js';
import Col from '../../LayoutSystem/Col.js';
import '../../LayoutSystem/Row.js';
import Skeleton from '../../Skeleton/index.js';

var ResumeItemSkeleton = function () {
    return (React__default.createElement(LabelWrapper, null,
        React__default.createElement(ResumeItemWrapper, { align: 'middle' },
            React__default.createElement(Col, { xs: 'auto' },
                React__default.createElement(Skeleton, { height: 32, width: 32 })),
            React__default.createElement(CvSection, { isSkeleton: true, xs: 'fill' },
                React__default.createElement("div", { style: { marginBottom: 8 } },
                    React__default.createElement(Skeleton, { height: 17 })),
                React__default.createElement(Skeleton, { height: 15, width: 150 })))));
};

export { ResumeItemSkeleton as default };
//# sourceMappingURL=ResumeItem.skeleton.js.map
